import React from 'react'
import packageJson from '../../../package.json'
import clsx from 'clsx'
import Button from '../ui-kit/Button/Button'
import { isEmbed } from '../consts'
import staticConfig from 'src/config'
import useBreakpoint from '../hooks/ui/useBreakpoint'
import { useTranslation } from 'react-i18next'

interface VersionProps {
  className?: string
}

const { isProdMode } = staticConfig

const disclaimerLink = staticConfig.resources.swarmX.terms.disclaimer

const Version: React.FC<VersionProps> = ({ className }) => {
  const { t } = useTranslation('common')

  const dotcV1Url = isProdMode
    ? 'https://app.swarm.com/v1'
    : 'https://dev.swarm.com/v1'

  const handleSwitchToV1 = () => window.open(dotcV1Url, '_blank')

  const isSm = useBreakpoint('sm')

  return (
    <div
      className={clsx(
        'flex items-center gap-3',
        'bg-paper border rounded border-main py-1 px-2', // Mobile classes
        'md:bg-transparent md:border-none md:py-0 md:px-0', // Reset mobile classes for Desktop
        className
      )}
    >
      <div className='flex flex-col'>
        <span className='text-label1 text-accent font-semibold'>
          {t('version.title', { version: packageJson.version })}
        </span>
        <a
          href={disclaimerLink}
          target='_blank'
          rel='noopener noreferrer'
          className='text-label1 text-main hover:text-main-accent transition-colors leading-3'
        >
          {t('version.disclaimer')}
        </a>
      </div>
      {isEmbed && !isSm && (
        <Button onClick={handleSwitchToV1} variant='outlined' size='sm'>
          {t('version.switchToV1')}
        </Button>
      )}
    </div>
  )
}

export default Version
